import { FC, SVGProps } from 'react';

export const FewerOptionsIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.9231 10.2772C19.5744 10.6259 19.0091 10.6259 18.6604 10.2772L15.7166 7.33341C15.6775 7.29436 15.6142 7.29436 15.5752 7.33341L12.6314 10.2772C12.2827 10.6259 11.7174 10.6259 11.3687 10.2772C11.02 9.9285 11.02 9.36318 11.3687 9.01449L15.0145 5.36866C15.3632 5.01998 15.9285 5.01998 16.2772 5.36866L19.9231 9.01449C20.2717 9.36318 20.2717 9.9285 19.9231 10.2772Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.9231 21.8895C19.5744 21.5408 19.0091 21.5408 18.6604 21.8895L15.7166 24.8333C15.6775 24.8723 15.6142 24.8723 15.5752 24.8333L12.6314 21.8895C12.2827 21.5408 11.7174 21.5408 11.3687 21.8895C11.02 22.2382 11.02 22.8035 11.3687 23.1522L15.0145 26.798C15.3632 27.1467 15.9285 27.1467 16.2772 26.798L19.9231 23.1522C20.2717 22.8035 20.2717 22.2382 19.9231 21.8895Z"
			fill="currentColor"
		/>
	</svg>
);
